<template>
    <div>
        <div class="my-content-tabs my-content-1">
            <el-table :data="articleList" style="width: 100%">
                <el-table-column prop="name" label="成片" width="200px">
                    <template slot-scope="scope">
                        <div class="cover-box" @click="preview(scope.row)">
                            <i class="el-icon-caret-right cover-icon"></i>
                            <div class="video-time" v-text="formatDuration(scope.row.duration)"></div>
                            <div>
                                <img :src="scope.row.cover" v-if="scope.row.cover" style="border-radius: 5px;"
                                    width="177" height="100" alt="">
                                <div class="image-box-error" v-else>
                                </div>
                            </div>

                        </div>
                        <div style="text-align: center;margin-top: 5px;"><span>{{scope.row.name}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="成片信息" align="left">
                    <template slot-scope="scope">
                        <div>分辨率：<span>{{scope.row.width}}x{{scope.row.height}}</span></div>
                        <div>大小：<span v-html="formatSize(scope.row.size)"></span></div>
                        <div>生成时间：<span>{{scope.row.ctime}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="progress" label="导出进度" align="center">
                    <template slot-scope="scope">
                        <el-progress :width="35" :stroke-width="2" type="circle" v-if="scope.row.status === 0"
                            :percentage="scope.row.progress"></el-progress>
                        <el-progress :width="35" :stroke-width="2" type="circle" v-else
                            :percentage="scope.row.progress" :status="getStatus(scope.row.status)">
                        </el-progress>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size="small" @click="toContribute(scope.row)">投稿
                            </el-button>
                            <el-button type="primary" size="small" @click="download(scope.row)">下载</el-button>
                            <el-button type="danger" size="small" @click="deleteArticle(scope.row)">删除
                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="pageChange">
            </el-pagination>
        </div>
        <!-- 视频预览 -->
        <el-dialog title="预览" :visible.sync="previewVisible" width="600px" :before-close="closeVideo">
            <div>
                <video ref="videoPreview" controls style="width: 100%" :src="previewUrl"></video>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    CmeProjectDelete,
    CmeCreatureList,
    CmeCreatureInfo,
    CmeCreatureDownload,
    CmeCreatureDelete,
    QcloudUgcvideoView
} from 'Services/getData.js';
import { setInterval, clearInterval } from 'timers';
export default {
    data() {
        return {
            total: 0,
            articleList: [],
            params: {
                page: 1,
                pageSize: 10
            },
            previewVisible: false,
            previewUrl: ''
        }
    },
    mounted() {
        this.getArticleList();
    },
    methods: {
        closeVideo() {
            this.$refs.videoPreview.pause();
            this.previewVisible = false;
        },
        async preview(item) {
            if (item.status !== 1) {
                this.$message({
                    message: '请等待视频导出完成后预览',
                    type: 'warning'
                });
                return;
            }
            const res = await QcloudUgcvideoView({
                url: item.url
            })
            if (res.status === 200 && res.data.code === 0) {
                this.previewUrl = res.data.data.url;
                this.$nextTick(() => {
                    console.log(this.$refs.videoPreview)
                    this.$refs.videoPreview.play();
                })
            }
            this.previewVisible = true;
        },
        async getCmeCreatureInfo(id, k, timer) {
            const res = await CmeCreatureInfo({
                taskId: id
            })
            if (res.status === 200 && res.data.code === 0) {
                this.$set(this.articleList, k, res.data.data);
                if (res.data.data.status === 1) {
                    clearInterval(timer);
                }
            }
        },
        async toContribute(item) {
            if (item.status !== 1) {
                this.$message({
                    message: '请选择导出完成的视频进行投稿',
                    type: 'warning'
                });
                return;
            }
            this.$router.push({
                name: 'v4-contribute-contribute',
                query: {
                    cmeId: item.id
                }
            })
        },
        async download(item) {
            const res = await CmeCreatureDownload({
                taskId: item.id
            })
            if (res.status === 200 && res.data.code === 0) {
                const url = res.data.data.split('//')[1]
                let openEl = document.createElement('a');
                openEl.href = `https://${url}&download_name=123.mp4`;
                openEl.click();
            }
        },
        formatDate(item) {
            return item.ctime.split(' ').join('<br>')
        },
        getStatus(status) {
            switch (status) {
                case 0:
                    // 处理中
                    return 'warning';
                case 1:
                    // 处理成功
                    return 'success';
                case 2:
                    // 处理失败
                    return 'exception';
            }
            return 'warning'
        },
        toEdit(id = '') {
            console.log(id)
            const routeData = this.$router.resolve({
                name: 'center-cme-edit',
                query: {
                    id: id
                }
            });
            window.open(routeData.href, '_blank');
        },
        async getArticleList() {
            this.articleList = [];
            const res = await CmeCreatureList(this.params)
            if (res.status === 200 && res.data.code === 0) {
                this.articleList = res.data.data.data;
                this.articleList.forEach((v, k) => {
                    if (v.status === 0) {
                        let timer = setInterval(() => {
                            this.getCmeCreatureInfo(v.id, k, timer);
                        }, 2000)
                    }
                })
                this.total = res.data.data.total;
            }
        },
        pageChange(page) {
            console.log(page)
            this.params.page = page;
            this.getArticleList();
        },
        deleteArticle(item) {
            let self = this;
            this.$confirm('确认删除此内容').then(async () => {
                let res = await CmeCreatureDelete({
                    taskId: item.id
                });
                if (res.status === 200 && res.data.code == 0) {
                    this.$alert('删除成功');
                }
                this.getArticleList();
            }).catch((e) => {
                console.log(e);
            });
        },
        formatSize(limit = 0) {
            let size = "";
            limit = Number(limit);
            if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B  
                size = `${limit.toFixed(1)}B`;
            } else if (limit < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB  
                size = `${(limit / 1024).toFixed(1)}KB`;
            } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB  
                size = `${(limit / (1024 * 1024)).toFixed(1)}MB`;
            } else { //其他转化成GB  
                size = `${(limit / (1024 * 1024 * 1024)).toFixed(1)}GB`;
            }

            let sizestr = `${size}`;
            let len = sizestr.indexOf("\.");
            let dec = sizestr.substr(len + 1, 2);
            if (dec == "00") {//当小数点后为00时 去掉小数部分  
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
            }
            return sizestr;
        },
        formatDuration(a) {
            var b = ""
            var h = parseInt(a / 3600),
                m = parseInt(a % 3600 / 60),
                s = parseInt(a % 3600 % 60);
            if (h > 0) {
                h = h < 10 ? '0' + h : h
                b += h + ":"
            }
            m = m < 10 ? '0' + m : m
            s = s < 10 ? '0' + s : s
            b += m + ":" + s
            return b;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/manage/content.scss";
.my-content {
    .add-btn {
        margin-bottom: 20px;
    }
    .freelance-list {
        .txt {
            padding-left: 20px;
        }
    }
}
.image-box-error {
    width: 177px;
    height: 100px;
    background: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: center;
}
.list {
    height: 142px;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
.cover-box {
    position: relative;
    cursor: pointer;
    .cover-icon {
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        position: absolute;
        font-size: 30px;
        padding: 3px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .video-time {
        font-size: 12px;
        background: #333;
        border-radius: 2px;
        padding: 3px 10px;
        line-height: 1;
        position: absolute;
        right: 5px;
        bottom: 5px;
        color: #fff;
    }
}
</style>